import React from 'react';
import { ReportModalContextProvider } from 'contexts/ReportModalContext';
import './EHRPage.css';
import { LoadingHU } from 'components/LoadingHU';
import { useEHRContext } from 'contexts/EHRContext';
import { EHRArea, ProfileSummaryArea } from './components';

export function EHRPage({ page }) {
  const { loading } = useEHRContext();

  return (
    <ReportModalContextProvider>
      {loading ? (
        <LoadingHU state />
      ) : (
        <>
          {!page && <ProfileSummaryArea />}
          <EHRArea page={page} />
        </>
      )}
    </ReportModalContextProvider>
  );
}
